/* eslint-disable react-hooks/rules-of-hooks */
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { setIsLoading } from './summary.slice';

export default function useSummary() {
  const summary = useSelector((state) => state.summary, shallowEqual);

  const dispatch = useDispatch();

  const setIsLoadingSummary = (value) => {
    console.log('setIsLoadingSummary', value);
    dispatch(setIsLoading(value));
  };

  return {
    summary,
    setIsLoadingSummary,
  };
}
